import _ from 'lodash';
import ApiService from '../services/ApiService';
import toastr from '../components/toastr';

const cancelInvoice = async ({ creditInvoiceNum, customerNum, invoiceNum, ppc }) => {
  const res = await ApiService.post('/shopkeeper/ccinvoicevoid', { creditInvoiceNum, customerNum, invoiceNum, ppc });
  const parsedResponse = _.get(res, 'data.dbpip', '').split('\n');
  const legacyErrors = _.get(parsedResponse, 12, '').trim();

  if (legacyErrors) {
    const processErrors = [];
    processErrors.push(...legacyErrors.split('ý'));
    processErrors.forEach(error => {
      toastr.error('Legacy Error', error);
    });
    console.error('Legacy Cancel Invoice Errors');
    console.log(processErrors);

    throw new Error('Legacy Cancel Invoice Errors');
  } else {
    toastr.error('Canceled', 'Invoice Canceled');
  }
};

// Returns Array<{ id: string, name: string }>
// Possible to be [] if the site has only 1 default printer, vey rare
const fetchCashInvoicePrinters = async () => {
  let res;
  try {
    res = await ApiService.get('/shopkeeper/cashinvoiceprinterslist');
  } catch (err) {
    console.error(err);
    return [];
  }
  return _.get(res, 'data.printers', []);
};

const validateInvoice = async ({ customerNum, invoiceNum, ppc, printerID, printerName, transactions }) => {
  const res = await ApiService.post('/shopkeeper/ccinvoicevalidate', {
    customerNum,
    invoiceNum,
    ppc,
    printerID,
    transactions,
  });

  const parsedResponse = _.get(res, 'data.dbpip', '').split('\n');
  const legacyErrors = _.get(parsedResponse, 12, '').trim();

  if (legacyErrors) {
    const processErrors = [];
    processErrors.push(...legacyErrors.split('ý'));
    processErrors.forEach(error => {
      toastr.error('Legacy Error', error);
    });
    console.error('Legacy Validate Invoice Errors');
    console.log(processErrors);

    throw new Error('Legacy Validate Invoice Errors');
  } else {
    toastr.success('Complete', 'Invoice Validated');

    if (printerName === 'Screen') {
      // Phil's response is IDýDOCTITLEýURLýDOCTITLEýURL...
      const docInfo = _.get(parsedResponse, 10, '').trim().split('ý').slice(1);
      const screenPrintDocs = [];

      if (docInfo.length > 0) {
        for (let i = 0; i < docInfo.length; i += 2) {
          screenPrintDocs.push({
            title: docInfo[i],
            url: docInfo[i + 1],
          });
        }
      } else {
        console.error('Error', 'No document URLs returned.');
      }

      return { screenPrintDocs };
    }
  }
};

export { cancelInvoice, fetchCashInvoicePrinters, validateInvoice };
